import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import DesktopLeftColumn from "@layout/Login/desktopLeftColumn";

import HomeAnimation from "./components/HomeAnimation";

function Home() {
  
  const [width, setWidth] = useState(null);
  const desktopObserver = useRef(null);

  const handleDesktopResize = () => {
    if (desktopObserver?.current?.offsetWidth >= 1200) {
      setWidth(prev => (prev = desktopObserver?.current?.offsetWidth));
    } else {
      setWidth(prev => (prev = 0));
    }
  };

  const resizeObserver = new ResizeObserver(handleDesktopResize);

  useEffect(() => {
    resizeObserver.observe(desktopObserver.current);
    return () => {
      resizeObserver.disconnect();
    };
  });

  return (
    <Container className="home-container" ref={desktopObserver} fluid>
      <Row style={{ height: "100vh" }}>
        
        {
        width >= 1200 ? (
          <Col xl="8" xxl="9" style={{ display: "grid" }}>
            <DesktopLeftColumn />
          </Col>
        ) : null }
        

        <Col
          xl="4"
          xxl="3"
          style={{padding: '0'}}
          className="d-flex justify-content-center enterAnimation" // classe exemplo da animação e componente exemplo
        >
          <HomeAnimation />
          <Outlet />
        </Col>

      </Row>

    </Container>

  );
}

export default Home;
